/**
 * 日历、直播nav和搜索
 */

import React, { PureComponent, Fragment } from 'react';
import Chip from 'Chip';
import PropTypes from 'prop-types';
import { formatUrl } from '@ifeng-fe/public_method';
import styles from './index.css';
import Calendar from './calender';
import Search from './search';
import ImgNav from './imgNav';

class Tools extends PureComponent {
    static propTypes = {
        live: PropTypes.object,
    };

    render() {
        const { live } = this.props;

        return (
            <Fragment>
                <div className={styles.tools_box}>
                    <div className={styles.tools_main}>
                        {/* 财经日历 */}
                        <Calendar />
                        {/* 全球直播 */}
                        <div className={styles.ml14}>
                            <Chip id="170043" type="struct" title="导航" groupName="正文" content={live}>
                                <ImgNav />
                            </Chip>
                        </div>
                        {/* 跳转搜索 */}
                        <Search />
                    </div>
                </div>
            </Fragment>
        );
    }
}

/**
 * 定义组件属性类型
 * */
Tools.propTypes = {};

/**
 * 定义组件默认属性
 * */
Tools.defaultProps = {};

export { Tools };
export default Tools;
